import 'whatwg-fetch';
import 'es6-promise';
import utils from "../libs/utils";

let lyc_base_routes = utils.localStorageGet('lyc_base_routes');

let mid_ware_proxy_ip = lyc_base_routes['mid_ware_proxy_ip'];
let active_domain = lyc_base_routes['active_domain'];
let active_auth_domain = lyc_base_routes['active_auth_domain'];
const current_login_page = '&login_page=' + active_domain + '/lyc_auth_www/lyc/html/lyc_sign_in.html';
let active_sign_in_url = active_auth_domain + `/oauth/authorize?client_id=Lingyun_mall&response_type=code&state=certificate_state&redirect_uri=${active_domain}` + current_login_page;
let active_sign_up_url = active_auth_domain + `/oauth/authorize?client_id=Lingyun_mall&response_type=code&state=certificate_state&redirect_uri=${active_domain}&to_page=sign` + current_login_page;
let imgBaseUrl = 'https://a-lgc-show.obs.cn-north-4.myhuaweicloud.com/lingyun_market_main_images';
const objBaseURL = 'https://a-lgc-show.obs.cn-north-4.myhuaweicloud.com';
let baseMethods = {
    web_domain: active_domain,
    lgc_api_proxy_raw: '/lgc_api/sobeyMallProduct',
    auth_center_singIn: active_sign_in_url,
    auth_center_singUp: active_sign_up_url,
    siteCode: utils.localStorageGet('siteCode'),
};
baseMethods.base_images_Url = {
    header_hot: imgBaseUrl + '/icon/hot_icon.png',
    header_new: imgBaseUrl + '/icon/new_icon.png',
    main_banner_back_02: imgBaseUrl + '/case/case_moc.png',
    main_banner_back_01: imgBaseUrl + '/banner/banner_back.png',
    cloud_store_01: imgBaseUrl + '/product/cloud_store_01.png',
    cloud_smart_01: imgBaseUrl + '/product/cloud_smart_01.png',
    cloud_video_01: imgBaseUrl + '/product/cloud_video_01.png',
    img1: imgBaseUrl + '/view/components/footer/img/Group%202%402x.png',
    img2: imgBaseUrl + '/view/components/footer/img/Group%402x.png',
    img3: imgBaseUrl + '/view/Operation/img/05.png',
    img4: imgBaseUrl + '/view/Operation/img/23.png',
    img5: imgBaseUrl + '/view/Operation/img/02.png',
    img6: imgBaseUrl + '/view/Operation/img/Group%203%402x.png',
    img7: imgBaseUrl + '/view/Operation/img/laptop-3190194_1920%402x.png',
    img8: imgBaseUrl + '/view/Operation/img/laptop-3190194_19201%402x.png',
    img9: imgBaseUrl + '/view/Operation/img/laptop-3190194_19202%402x.png',
    img10: imgBaseUrl + '/view/Operation/img/Group%205%402x.png',
    img12: imgBaseUrl + '/view/Solution/IntegrationMedia/img/Group%202%402x.png',
    img13: imgBaseUrl + '/view/Solution/IntegrationMedia/img/Group%205%402x.png',
    img14: imgBaseUrl + '/view/Solution/IntegrationMedia/img/Group%207%402x.png',
    img15: imgBaseUrl + '/view/Solution/IntegrationMedia/img/Group%208%402x.png',
    imgLogo: imgBaseUrl + '/logo/logo_sobey_and_name.png',
    // func_img_01: imgBaseUrl + '/func/func_01.png',
    defaultBanner: imgBaseUrl + '/banner/default_banner.png',
    banner_contact_us_01: imgBaseUrl + '/banner/banner_contact_us_01.png',
    banner_img_ai: imgBaseUrl + '/banner/banner_img_ai.png',
    banner_img_cloud: imgBaseUrl + '/banner/banner_img_cloud.png',
    banner_img_cpu: imgBaseUrl + '/banner/banner_img_cpu.png',
    banner_img_ccbn: imgBaseUrl + '/banner/banner_img_ccbn.png',
    contact_phone_01: imgBaseUrl + '/icon/contact_phone_01.png',
    customer_service_01: imgBaseUrl + '/icon/customer_service_01.png',
    notice_info_banner_01: imgBaseUrl + '/banner/notice_info_banner_01.png',
    combinedCloud: imgBaseUrl + '/view/Solution/IntegrationMedia/img/combinedCloud.png',
    publicCloud: imgBaseUrl + '/view/Solution/IntegrationMedia/img/publicCloud.png',
    // lightMedia1: imgBaseUrl + '/view/Solution/LightMedia/img/Group-9%403x.png',
    lightMedia1: imgBaseUrl + '/view/Solution/LightMedia/img/multi_end.png',
    lightMedia2: imgBaseUrl + '/view/Solution/LightMedia/img/multiNodes.png',
    lightMedia3: imgBaseUrl + '/view/Solution/LightMedia/img/multiAdaptive.png',
    lightMedia4: imgBaseUrl + '/view/Solution/LightMedia/img/Group%207%402x.png',
    lightMedia5: imgBaseUrl + '/view/Solution/LightMedia/img/cloudOri.png',
    cloudSolution01: imgBaseUrl + '/view/Solution/LightMedia/img/company01.jpg',
    cloudSolution02: imgBaseUrl + '/view/Solution/LightMedia/img/company02.jpg',
    cloudSolution03: imgBaseUrl + '/view/Solution/LightMedia/img/company03.jpg',
    news1: imgBaseUrl + '/view/Solution/News/img/Group%209%403x.png',
    news2: imgBaseUrl + '/view/Solution/News/img/Group%202%402x.png',
    news3: imgBaseUrl + '/view/Solution/News/img/Group%203%402x.png',
    news4: imgBaseUrl + '/view/Solution/News/img/Group%204%402x.png',
    news5: imgBaseUrl + '/view/Solution/News/img/Group%205%402x.png',
    news6: imgBaseUrl + '/view/Solution/News/img/img5.png',
    news7: imgBaseUrl + '/view/Solution/News/img/img6.png',
    provincePlatform2: imgBaseUrl + '/provincePlatform/professional.png',
    provincePlatform3: imgBaseUrl + '/provincePlatform/open01.png',
    provincePlatform4: imgBaseUrl + '/provincePlatform/convenient.png',
    provincePlatform5: imgBaseUrl + '/provincePlatform/standard.png',
    lightM01: imgBaseUrl + "/provincePlatform/lightM01.png",
    lightM02: imgBaseUrl + "/provincePlatform/lightM02.png",
    lightM03: imgBaseUrl + "/provincePlatform/lightM03.png",
    anhui01: imgBaseUrl + "/provincePlatform/anhui01.png",
    dehong01: imgBaseUrl + "/provincePlatform/dehong01.png",
    guizhou01: imgBaseUrl + "/provincePlatform/guizhou01.jpg",
    sichuan01: imgBaseUrl + "/provincePlatform/sichuan01.jpg",
    zhejiang01: imgBaseUrl + "/provincePlatform/zhejiang01.png",
    zhejiangGold: imgBaseUrl + "/provincePlatform/zhejiangGold.png",

    icon_product_media: imgBaseUrl + '/icon/icon_product_media.png',
    icon_product_live: imgBaseUrl + '/icon/icon_product_live.png',
    icon_product_cutting: imgBaseUrl + '/icon/icon_product_cutting.png',
    icon_product_interactive: imgBaseUrl + '/icon/icon_product_interactive.png',
    icon_product_data: imgBaseUrl + '/icon/icon_product_data.png',

    products_videos_background: imgBaseUrl + '/background/products_videos_background.png',
    background_earth: imgBaseUrl + '/background/background_earth.png',
    circle_before_title: imgBaseUrl + '/background/circle_before_title.png',
    coor_shake_hands: imgBaseUrl + '/background/coor_shake_hands.png',
    home_register_back: imgBaseUrl + '/background/home_register_back.png',

    logo_aws: imgBaseUrl + '/logo/logo_aws.png',
    logo_tencent: imgBaseUrl + '/logo/logo_tencent.png',
    logo_huawei: imgBaseUrl + '/logo/logo_huawei.png',
    logo_agora: imgBaseUrl + '/logo/logo_agora.png',
    logo_senseTime: imgBaseUrl + '/logo/logo_senseTime.png',
    logo_baidu: imgBaseUrl + '/logo/logo_baidu.png',
    logo_heima: imgBaseUrl + '/logo/logo_heima.png',
    logo_iflyTek: imgBaseUrl + '/logo/logo_iflyTek.png',
    logo_telecom: imgBaseUrl + '/logo/logo_telecom.png',
    logo_alibaba: imgBaseUrl + '/logo/logo_alibaba.png',
    logo_faceUnity: imgBaseUrl + '/logo/logo_faceUnity.png',


    advantage_icon_01: imgBaseUrl + '/icon/advantage_icon_01.gif',
    advantage_icon_02: imgBaseUrl + '/icon/advantage_icon_02.gif',
    advantage_icon_03: imgBaseUrl + '/icon/advantage_icon_03.gif',
    advantage_icon_04: imgBaseUrl + '/icon/advantage_icon_04.gif',

    icon_play_btn: imgBaseUrl + '/icon/icon_play_btn.png',
    icon_video: imgBaseUrl + '/icon/icon_video.png',
    icon_cloud: imgBaseUrl + '/icon/icon_cloud.png',
    icon_camera: imgBaseUrl + '/icon/icon_camera.png',
    icon_expand: imgBaseUrl + '/icon/icon_expand.png',
    icon_func_item: imgBaseUrl + '/icon/icon_func_item.png',
    icon_circle_reverse: imgBaseUrl + '/icon/icon_circle_reverse.png',

    case_title: imgBaseUrl + '/banner/case_title.png',
    app_back_media: imgBaseUrl + '/app/app_back_media.png',
    app_back_news: imgBaseUrl + '/app/app_back_news.png',
    app_back_variety: imgBaseUrl + '/app/app_back_variety.png',
    app_back_ai: imgBaseUrl + '/app/app_back_ai.png',
    app_back_education: imgBaseUrl + '/app/app_back_education.png',
    app_back_meeting: imgBaseUrl + '/app/app_back_meeting.png',
    app_back_entertainment: imgBaseUrl + '/app/app_back_entertainment.png',
    app_back_medical: imgBaseUrl + '/app/app_back_medical.png',

    app_cover_media: imgBaseUrl + '/app/app_cover_media.png',
    app_cover_news: imgBaseUrl + '/app/app_cover_news.png',
    app_cover_variety: imgBaseUrl + '/app/app_cover_variety.png',
    app_cover_ai: imgBaseUrl + '/app/app_cover_ai.png',
    app_cover_education: imgBaseUrl + '/app/app_cover_education.png',
    app_cover_meeting: imgBaseUrl + '/app/app_cover_meeting.png',
    app_cover_entertainment: imgBaseUrl + '/app/app_cover_entertainment.png',
    app_cover_medical: imgBaseUrl + '/app/app_cover_medical.png',

    app_icon_media: imgBaseUrl + '/app/app_icon_media.png',
    app_icon_news: imgBaseUrl + '/app/app_icon_news.png',
    app_icon_variety: imgBaseUrl + '/app/app_icon_variety.png',
    app_icon_ai: imgBaseUrl + '/app/app_icon_ai.png',
    app_icon_education: imgBaseUrl + '/app/app_icon_education.png',
    app_icon_meeting: imgBaseUrl + '/app/app_icon_meeting.png',
    app_icon_entertainment: imgBaseUrl + '/app/app_icon_entertainment.png',
    app_icon_medical: imgBaseUrl + '/app/app_icon_medical.png',


    cover_media: imgBaseUrl + '/background/video_play_back_04.png',
    cover_block: imgBaseUrl + '/background/block_chain_back_01.png',
    cover_ai: imgBaseUrl + '/background/sobey_ai_01.png',
    cover_ultra: imgBaseUrl + '/background/ultra_HD_01.png',
    cover_media_convergence: imgBaseUrl + '/background/cover_media_convergence.png',
    cover_sobey_live: imgBaseUrl + '/background/cover_sobey_live.png',
    cover_sobey_ai: imgBaseUrl + '/background/cover_sobey_ai.png',

    product_introduce: imgBaseUrl + '/background/back_product_introduce.png',
    back_app_list: imgBaseUrl + '/background/back_app_list.png',
    back_blue_earth: imgBaseUrl + '/background/back_blue_earth.png',
};

baseMethods.base_video_URL = {
    home_video_sobey_intro: objBaseURL + '/lingyun_market_homePage_mp4/%E7%B4%A2%E8%B4%9DSobey%20Introduction.mp4',
    home_video_media_convergence: objBaseURL + '/lingyun_market_homePage_mp4/media_convergence.mp4',
    home_video_sobey_live: objBaseURL + '/lingyun_market_homePage_mp4/%E7%B4%A2%E8%B4%9D%E7%9B%B4%E6%92%ADSobey%20Live.mp4',
    home_video_sobey_ai: objBaseURL + '/SobeyAI.mp4',
};

console.log('sobey_lingyun branch last update on 2021-04-01 18:00');
if (-1 !== window.location.href.indexOf('localhost:300')) {
    baseMethods.fjl_api_proxy = '/fjl_api';
    baseMethods.lgc_api_proxy = '/lgc_api';
    baseMethods.wcy_api_proxy = '/wcy_api';
    baseMethods.wcy02_api_proxy = '/wcy02_api';
    baseMethods.wcy03_api_proxy = '/wcy03_api';
    baseMethods.task_monitor_api_proxy = '/task_monitor_api';
    baseMethods.fjiang6_mid_ip = '';
    baseMethods.temp_token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsiaGl2ZSIsInNvYmV5Il0sInVzZXJfaW5mbyI6eyJzaXRlIjoic29iZXlMaW5nWXVuTWFsbCIsInVzZXJJZCI6IjIiLCJsb2dpbk5hbWUiOiJzb2JleXhpYW9kYW4iLCJ1c2VybmFtZSI6InNvYmV5eGlhb2RhbiIsInVzZXJDb2RlIjoiYmNmYmYwNzE5NDQ1NDQzOGE1NzcxZWVmZjg5OTJlYmQiLCJ1c2VyVHlwZSI6MCwicm9sZXMiOlsiUjdSNGdOaXgwQkMzVGlUR0c0MkFtaTRzeldoSFZrNFciLCJmaWN1c19iY2ZiZjA3MTk0NDU0NDM4YTU3NzFlZWZmODk5MmViZCIsIlFXd01KczdkRFg1alVWQ01oTFpYcktzOEJ0RjFZUzY3IiwiNWhGdHdwYnltSElpQjgxNDdGSXBUNGYxZW5OOUwyM3kiLCIzWjQ4QmJHbndaNkw1dUMxTEFKYUVlQ2daNUhQV0dKSSJdLCJwZXJtaXNzaW9ucyI6WyJMaW5neXVuX21hbGw6ZWYwOTJmZTQ4ZGNlNGUxM2JmNzQ3NjAzMGZjZDk2ZjY2MToqOioiXSwibG9ja2VkIjpmYWxzZSwiZGlzYWJsZSI6ZmFsc2UsImJvdW5kVHBhdXRoVHlwZXMiOltdLCJyb290VXNlciI6dHJ1ZSwicGFyZW50Q29kZSI6IjJkM2YyOGI3NGEzYTdlZGRkY2E0MTEzMTVjNDI3Mzg5IiwidHdvRmFjdG9yQ2hlY2siOmZhbHNlLCJwd2RDaGFuZ2VUaW1lIjoiMjAyMy0wMy0wNyAxODozNTozOCIsInB3ZENoYW5nZVBlcmlvZCI6LTEsImFjY291bnROb25Mb2NrZWQiOnRydWUsImFjY291bnROb25FeHBpcmVkIjp0cnVlLCJjcmVkZW50aWFsc05vbkV4cGlyZWQiOnRydWUsImVuYWJsZWQiOnRydWUsImFkbWluIjpmYWxzZX0sImdyYW50X3R5cGUiOiJwYXNzd29yZCIsInVzZXJfbmFtZSI6InNvYmV5eGlhb2RhbiIsInNjb3BlIjpbImFsbCJdLCJleHAiOjE2OTU2MzgyNzEsImF1dGhvcml0aWVzIjpbIlJPTEVfM1o0OEJiR253WjZMNXVDMUxBSmFFZUNnWjVIUFdHSkkiLCJST0xFX2ZpY3VzX2JjZmJmMDcxOTQ0NTQ0MzhhNTc3MWVlZmY4OTkyZWJkIiwiUk9MRV9SN1I0Z05peDBCQzNUaVRHRzQyQW1pNHN6V2hIVms0VyIsIlJPTEVfNWhGdHdwYnltSElpQjgxNDdGSXBUNGYxZW5OOUwyM3kiLCJST0xFX1FXd01KczdkRFg1alVWQ01oTFpYcktzOEJ0RjFZUzY3Il0sImp0aSI6IjkxYjZjOGVjLTQwMjctNDgwNy05NmE5LWQ5OTU0YzQ0NmZhZiIsImNsaWVudF9pZCI6Ikxpbmd5dW5fbWFsbCJ9.3869t8KgNIADfXmjlbKQqwgzHUY0Nhv1-QkRgNPFHm0';
    // utils.localStorageSet('lingyun_login_usercode', 'e138672e626c4d1da2d4b8c5bc34b193');
    // utils.localStorageSet('lingyun_login_username', '15928902955');
} else {
    baseMethods.fjl_api_proxy = mid_ware_proxy_ip + '/lyc_middle_ware/fjl_api';
    baseMethods.lgc_api_proxy = mid_ware_proxy_ip + '/lyc_middle_ware/lgc_api';
    baseMethods.wcy_api_proxy = mid_ware_proxy_ip + '/lyc_middle_ware/wcy_api';
    baseMethods.wcy02_api_proxy = mid_ware_proxy_ip + '/lyc_middle_ware/wcy02_api';
    baseMethods.wcy03_api_proxy = mid_ware_proxy_ip + '/lyc_middle_ware/wcy03_api';
    baseMethods.task_monitor_api_proxy = mid_ware_proxy_ip + '/lyc_middle_ware/task_monitor_api';
    baseMethods.fjiang6_mid_ip = mid_ware_proxy_ip;
    baseMethods.temp_token = '';
}


const headers01 = new Headers({
    "Accept": "application/json",
    "Content-Type": "application/json",
    'Authorization': baseMethods.temp_token,
});


baseMethods.get = (url, header02, responseType) => {
    return fetch(url, {
        method: 'GET',
        headers: header02 || headers01
    }).then(response => {
        return handleResponse(url, response, responseType)
    }).catch(err => {
        console.error(`get-Request failed. Url = ${url} . Message = ${err}`);
        return {
            error: {
                message: 'Request failed.'
            }
        };
    })
};


baseMethods.post = (url, data, header02, responseType) => {
    return fetch(url, {
        method: 'POST',
        headers: header02 || headers01,
        body: data ? JSON.stringify(data) : null,
    }).then(response => {
        return handleResponse(url, response, responseType);
    }).catch(err => {
        console.error(`Request failed. Url = ${url} . Message = ${err}${data}`);
        return {
            error: {
                message: 'Request failed.'
            }
        };
    })
};

baseMethods.postURL = (url, header02) => {
    return fetch(url, {
        method: 'POST',
        headers: header02 || headers01,
    }).then(response => {
        return handleResponse(url, response);
    }).catch(err => {
        console.error(`Request failed. Url = ${url} . Message = ${err}`);
        console.log(err);
        return {
            error: {
                message: 'Request failed.'
            }
        };
    })
};

baseMethods.formPost = (url, data, header02) => {
    return fetch(url, {
        method: 'POST',
        headers: header02 || headers01,
        body: data,
    }).then(response => {
        return handleResponse(url, response);
    }).catch(err => {
        console.error(`Request failed. Url = ${url} . Message = ${err}`);
        return {
            error: {
                message: 'Request failed.'
            }
        };
    })
};

baseMethods.delete = (url, data, header02) => {
    return fetch(url, {
        method: 'DELETE',
        headers: header02 || headers01,
        body: data ? JSON.stringify(data) : null,
    }).then(response => {
        return handleResponse(url, response);
    }).catch(err => {
        console.error(`Request failed. Url = ${url} . Message = ${err}`);
        return {
            error: {
                message: 'Request failed.'
            }
        };
    })
};

baseMethods.put = (url, data, header02) => {
    return fetch(url, {
        method: 'PUT',
        headers: header02 || headers01,
        body: data ? JSON.stringify(data) : null
    }).then(response => {
        return handleResponse(url, response);
    }).catch(err => {
        console.error(`Request failed. Url = ${url} . Message = ${err}`);
        return {
            error: {
                message: 'Request failed.'
            }
        };
    })
};

function handleResponse(url, response, responseType) {
    if (response.status < 500) {
        /*下载文件*/
        if (responseType) {
            if ('download' === responseType) {
                let filename = url.split('\\').pop().split('/').pop();
                response.blob().then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    let aElement = document.createElement('a'); //获取a标签元素
                    aElement.href = blobUrl; //设置a标签路径
                    aElement.download = filename;
                    aElement.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
                return filename;
            } else if ('no_feedback' === responseType) {
                return response
            }

        } else {
            return response.json() //返回普通json格式
        }
    } else {
        console.error(`Request failed. Url = ${url} . Message = ${response.statusText}`);
        return {
            error: {
                message: 'Request failed due to server error '
            }
        };
    }

}

export default baseMethods;



// WEBPACK FOOTER //
// ./src/api/baseMethods.js